export default "__VITE_ASSET__BoQ_a8g7__"